export default "__VITE_ASSET__fd9ee92a__"